export default [
  { naoNulo: true, tipo: 'string', atributo: 'codigo', nome: 'Código' },
  { naoNulo: true, tipo: 'string', atributo: 'nome', nome: 'Nome' },
];
